services.service('BlueprintRegistration', function () {

    this.create = function (type) {
        switch (type) {
        case 'long':
            return long;
        case 'questions':
            return questions;
        case 'affiliate':
            return affiliate;
        }
    };

    function long(data) {
        return {
            firstName: data.firstName || '',
            middleName: data.middleName || '',
            surname: data.surname || '',
            nationalID: data.nationalId || '',
            gender: (data.gender === 'male') ? 0 : 1,
            dob: moment(data.dateBirth).format("DD.MM.YYYY") || '',
            phone: data.phone || '',
            isMobilePhone: data.isMobilePhone ? 1 : 0,
            country: data.country || '',
            nationality: data.nationality || '',
            birthCountry: data.birthCountry || '',
            address: data.street || '',
            city: data.city || '',
            postalCode: data.zipCode || '',
            isUSCitizen: data.isUSCitizen ? 1 : 0,
            usTaxID: data.usTaxId || ''
        }
    }

    function questions(data) {
        return {
            tradingFrequency: data.freq,
            OTCDFrequency: data.deriv,
            ETDFrequency: data.exch,
            approveCFDTrading: data.permit ? 1 : 0,
            atv: data.total,
            investmentKnowledge: data.investm,
            employmentStatus: data.employ,
            annualIncome: data.finance,
            savingsInvestment: data.value
        }
    }

    function affiliate(data) {
        var _data;

        try {
            _data = JSON.parse(data);
        } catch (e) {
            return '';
        }

        var ref = _data.hasOwnProperty('data') && _data.data,
            afData = {
                c: ref.campaign || '',
                pid: ref.media_source || '',
                af_siteID: ref.af_siteid || '',
                af_sub1: ref.af_sub1 || '',
                af_sub2: ref.af_sub2 || '',
                af_sub3: ref.af_sub3 || '',
                af_sub4: ref.af_sub4 || '',
                af_sub5: ref.af_sub5 || '',
                clickID: ''
            };

        return Object.keys(afData)
            .reduce(function (arr, key) {
                return arr.concat(key + '=' + (afData[key] === 'null' ? '' : afData[key]));
            }, [])
            .join('|');
    }

    return this;
});